// extracted by mini-css-extract-plugin
export default {"products":"av-z","card":"bv-z","oosMessaging":"cv-z"};